import { useEffect, useMemo, useState } from 'react'

function useIsInViewport(ref) {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) =>
        setIsIntersecting(entry.isIntersecting),
      ),
    [],
  );
  useEffect(() => {
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);
  return isIntersecting;
}

const getActiveId = (blockRef) => {
  if (blockRef.current) {
    return Array.from(
      blockRef.current.querySelectorAll("a.anchor")
    ).filter(
      elt => (elt.getBoundingClientRect().y < 100)
    ).at(-1)?.id
  }
}

const useScrolledTableOfContent = (pageRef) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const isInViewport = useIsInViewport(pageRef);
  const [activeId, setActiveId] = useState(getActiveId(pageRef));
  const [menuFixed, setMenuFixed] = useState(false);
  const handleScroll = () => {
    setTimeout(()=>{
      const position = window.pageYOffset;
      setScrollPosition(position);
    }, 100)
  };
  const shouldFixMenu = (postion) => (scrollPosition > 285)
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    if(isInViewport) {
      setActiveId(getActiveId(pageRef))
      setMenuFixed(shouldFixMenu(scrollPosition))
    }
  }, [scrollPosition])

  return {activeId, menuFixed}
}

export default useScrolledTableOfContent